export const environment = {
    production: false,
    GSC_CLIENT_ID: '832592858099-eipsm4q5mhuagr9i87p7kalpjg1vh7do.apps.googleusercontent.com',
    GSC_API_PATH: 'https://accounts.google.com/gsi/client',
    API_URL: 'https://student-portal.eo.coditas.org/noveointbk/api/v1',
    JSP_BASE_URL: 'https://newtestasc.iitb.ac.in/onlinepay_git/SAP_Customer/index.jsp',
    JSP_APP_ID: '10150',
    USE_MOCK_DATA: false,
    RECAPTCHA_SITE_KEY: '6LfW_aosAAAAAH9Cyaz8yY0HMB7Z_rOh61qcKzoI',
};
